import { useUserData } from "components/customHooks/userDataContext";
import React, { useState, useEffect } from "react";
import {
  getEncounterFormBatchFile,
  getEncounterFormsBatchList,
  initiateEncounterFormsBatch,
} from "apiHandler/actions";
import Dropdown from "components/Dropdown";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { DataGrid } from "@mui/x-data-grid";
import {
  DataGridCustomPagination,
  displayDateFormatter,
} from "components/helpers";
import useSnackbar from "components/customHooks/useSnackbar";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { IconButton } from "@mui/material";

const EncounterForm = () => {
  const [formsData, setFormsData] = useState([]);
  const [dos, setDos] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const userData = useUserData();
  const token = userData?.access_token;
  const { CustomSnackbar, setSnackbarMessage } = useSnackbar();

  const fetchData = async () => {
    setLoading(true);
    const response = await getEncounterFormsBatchList(
      {
        practice_id: userData?.selected_practice,
      },
      token
    );
    if (response) setFormsData(response);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getFile = async (data) => {
    setSnackbarMessage("Getting PDF,Please wait...");
    const payload = {
      practice_id: userData?.selected_practice,
      id: data.id,
    };
    const response = await getEncounterFormBatchFile(payload, token);
    if (!response) setSnackbarMessage("Failed To Get PDF");
  };

  const generateForms = async () => {
    const payload = {
      practice_id: userData?.selected_practice,
      dos: displayDateFormatter(dos),
    };
    const response = await initiateEncounterFormsBatch(payload, token);
    if (response) setSnackbarMessage("Generating PDF");
    else setSnackbarMessage("Failed To Generate PDF");
  };
  const columns = [
    {
      field: "id",
      headerName: "ID",
      minWidth: 80,
      flex: 1,
      align: "center",
    },
    {
      field: "dos",
      headerName: "DOS",
      minWidth: 100,
      flex: 1,
      align: "center",
      renderCell: (e) => <div>{displayDateFormatter(e.value)}</div>,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 100,
      flex: 1,
      align: "center",
    },
    {
      field: "created_date",
      headerName: "Created Date",
      minWidth: 100,
      flex: 1,
      align: "center",
      renderCell: (e) => <div>{displayDateFormatter(e.value)}</div>,
    },
    {
      field: "encounters_count",
      headerName: "Count",
      minWidth: 100,
      flex: 1,
      align: "center",
    },
    {
      field: "test",
      headerName: " ",
      minWidth: 50,
      flex: 1,
      align: "center",
      renderCell: (e) => (
        <div>
          <IconButton onClick={() => getFile(e.row)}>
            <PictureAsPdfIcon />
          </IconButton>
        </div>
      ),
    },
  ];
  return (
    <div className="encounter-forms">
      <CustomSnackbar />
      <main>
        <div className="header">
          <Dropdown buttonName="Generate Encounter Forms">
            <div className="generate-forms">
              <KeyboardDatePicker
                // renderInput={(params) => (
                //   <TextField variant="standard" {...params} />
                // )}
                // error={error.dob}
                id="birth-date"
                placeholder="MM/DD/YYYY"
                format="MM/dd/yyyy"
                value={dos}
                onChange={(e) => setDos(e)}
                style={{ minWidth: "80%" }}
                autoOk
              />
              <button className="button" onClick={generateForms}>
                Submit
              </button>
            </div>
          </Dropdown>
        </div>
      </main>
      <div>
        <DataGrid
          rows={loading ? [] : formsData}
          columns={columns}
          autoHeight="true"
          disableRowSelectionOnClick
          pagination
          pageSize={50}
          density="compact"
          slots={{
            pagination: DataGridCustomPagination,
          }}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default EncounterForm;
